import { render } from "./Average.vue?vue&type=template&id=53c382e8"
import script from "./Average.vue?vue&type=script&lang=js"
export * from "./Average.vue?vue&type=script&lang=js"

import "./Average.vue?vue&type=style&index=0&id=53c382e8&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__